module.exports = __webpack_public_path__ + "57020bd142cbe275fb9c2401cc9e07cb.fbx";